"use client";
import TechnologiesPages from "@/components/Technologies/TechnologiesPages";

export default function TechnologyPage() {
  return <TechnologiesPages />;
}
